import { API_HELPER } from '@/helpers/api.js';

const API_ROOT_SERVICE = 'Reservations';

export const RESERVATIONS_SERVICE = {
    createReservation,
    getReservations,
    getReservationById,
    updateReservation,
    deleteReservation,
    checkSlotAvailability
};

function createReservation(reservationData) {
    const url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(reservationData)
    };

    return API_HELPER.apiCall(url, null, requestOptions);
}

function getReservations(filter = {}, status = null) {
    const queryParams = { ...filter };
    if (status) {
        queryParams.status = status;
    }
    const url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);
    
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function getReservationById(id) {
    const url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id.toString()]);
    
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function updateReservation(reservationData) {
    const url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);
    
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(reservationData)
    };

    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function deleteReservation(id) {
    const url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id.toString()]);
    
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function checkSlotAvailability(experienceAvailabilityId, requestedPeople = 1) {
    const params = new URLSearchParams({ requestedPeople: requestedPeople.toString() });
    const url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, 'SlotAvailability', experienceAvailabilityId.toString()]) + '?' + params.toString();

    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return API_HELPER.apiCall(url, null, requestOptions)
        .catch(error => {
            console.error('Error in checkSlotAvailability:', error);
            // Return unavailable on error to prevent overbooking
            return { isAvailable: false, availableSpots: 0, maxPeople: 0, totalReservedPeople: 0, reservationCount: 0 };
        });
}
